import { createConfig, http } from 'wagmi';
import { bsc, mainnet, polygon } from 'wagmi/chains';
import { walletConnect } from 'wagmi/connectors';
import { WC_PROJECT_ID } from './constants';

declare module 'wagmi' {
	interface Register {
		config: typeof config;
	}
}

export const config = (() => {
	if (!WC_PROJECT_ID) throw new Error('WALLET_CONNECT_PROJECT_ID is not set');

	return createConfig({
		chains: [polygon, mainnet, bsc],
		connectors: [
			walletConnect({
				metadata: {
					description: 'Link wallet with foodriver telegram mini app',
					icons: [`${globalThis.location.origin}/favicon/favicon.ico`],
					name: 'FooDriver TMA',
					url: globalThis.location.origin,
				},
				projectId: WC_PROJECT_ID,
			}),
		],
		ssr: false,
		transports: {
			[polygon.id]: http(polygon.rpcUrls.default.http[0]),
			[mainnet.id]: http('https://bsc-mainnet.infura.io/v3/adb27fcc69d3421f963d64e05439b327'),
			[bsc.id]: http(bsc.rpcUrls.default.http[0]),
		},
	});
})();
